var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "id": "irrigation",
            "title": "솔루션",
            "src": "/images/sub/subvisual-solution.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first",
    scopedSlots: _vm._u([{
      key: "titleLine",
      fn: function fn() {
        return [_vm._v(" 스마트팜 제품 솔루션 ")];
      },
      proxy: true
    }])
  }, [_c('tit-wrap-large', {
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_vm._v(" 재배지의 현재 상태를 진단하여 작물이 필요한 만큼의 관수공급으로 농업용수를 절약하고, "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("구역별 시간, 유량 설정, 수분 포함량 편차에 따른 스마트 관수제어 기능으로 관수를 최적화하여 작물 생장에 도움을 줍니다. ")];
      },
      proxy: true
    }])
  }, [_vm._v(" 재배지 관리를 손쉽게 만드는 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _c('b', [_vm._v("스마트 관수제어 통합 시스템")])]), _c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "528",
      "aspect-ratio": 528 / 786,
      "src": "/images/sub/solution/smartfarm/irrigation-img.png",
      "data-aos": "fade",
      "data-aos-delay": "100"
    }
  })], 1), _c('v-container', [_c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('page-section', [_c('page-section', {
    staticClass: "page-section--sm py-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-row', {
          staticClass: "mx-n20px my-n10px mx-md-n30px my-md-n20px"
        }, [_c('v-col', {
          staticClass: "px-20px py-10px px-md-30px py-md-20px",
          attrs: {
            "cols": "12",
            "md": "6",
            "data-aos": "fade-left",
            "data-aos-delay": "200"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 570 / 456,
            "content-class": "d-flex pa-20px"
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "242",
            "aspect-ratio": 242 / 348,
            "src": "/images/sub/solution/smartfarm/irrigation-img2.png"
          }
        })], 1)], 1)], 1), _c('v-col', {
          staticClass: "px-20px py-10px px-md-30px py-md-20px",
          attrs: {
            "cols": "12",
            "md": "6",
            "data-aos": "fade-right",
            "data-aos-delay": "200"
          }
        }, [_c('div', {
          staticClass: "mt-md-24px"
        }, [_c('tit-wrap-sprout', [_vm._v(" 스마트 관수제어 시스템 ")]), _c('txt-item', {
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("제어항목")];
            },
            proxy: true
          }])
        }, [_vm._v(" 시간제어, 광량제어,무게제어 "), _c('div', {
          staticClass: "font-size-16 font-size-md-18"
        }, [_vm._v("*중량제어 기반 양액관리 알고리즘 탑재")])]), _c('txt-item', {
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("관수방식")];
            },
            proxy: true
          }])
        }, [_vm._v(" 시간관수, 유량관수, 함수량 관수 ")]), _c('txt-item', {
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("설정항목")];
            },
            proxy: true
          }])
        }, [_vm._v(" 구역 설정 (최대 10개)"), _c('br'), _vm._v("구역별 관수주기"), _c('br'), _vm._v("관수기간"), _c('br'), _vm._v("구역별 EC, pH 개별 설정"), _c('br'), _vm._v("작물 1주당 관수량"), _c('br'), _vm._v("EC, pH 상하한경보 ")]), _c('txt-item', {
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("조회항목")];
            },
            proxy: true
          }])
        }, [_vm._v(" 양액기 운영 기록, 근권부 모니터링 기록, "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("온실환경 실시간 및 기간별 조회 ")]), _c('txt-item', {
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("기타기능")];
            },
            proxy: true
          }])
        }, [_vm._v(" 긴급상황 수동관수 기능 ")])], 1)])], 1)];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-card', {
          attrs: {
            "rounded": "",
            "color": "grey lighten-5",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 1200 / 770,
            "content-class": "d-flex align-center justify-center"
          }
        }, [_c('div', {
          staticClass: "pa-30px pa-md-40px px-lg-80px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": "600",
            "width": _vm.$vuetify.breakpoint.lgAndUp ? '600' : '',
            "aspect-ratio": 600 / 376,
            "src": "/images/sub/solution/smartfarm/irrigation-img3.png"
          }
        }), _c('div', {
          staticClass: "pt-30px pt-md-40px pt-lg-60px"
        }, [_c('tit-wrap-small', {
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" 양액기 운영기록과 근권부 모니터링, 온실환경 등 다양한 기록을 통해 "), _c('br', {
                staticClass: "d-none d-lg-block"
              }), _vm._v("재배환경 설정 판단을 도와주는 시스템입니다. ")];
            },
            proxy: true
          }])
        }, [_vm._v(" 웹과 모바일 앱에서 쉽고 간편한 실시간 모니터링 ")])], 1)], 1)])], 1)];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-row', {
          attrs: {
            "justify": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6",
            "lg": "4",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "382",
            "aspect-ratio": 382 / 540,
            "src": "/images/sub/solution/smartfarm/irrigation-img4.jpg"
          }
        })], 1), _c('tit-wrap-small', {
          staticClass: "mt-14px mt-md-20px",
          attrs: {
            "mbSmall": ""
          },
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" 양액재배 관리장치 ")];
            },
            proxy: true
          }])
        }, [_vm._v(" 특허등록 ")])], 1)], 1)];
      },
      proxy: true
    }])
  })], 1), _c('page-section', {
    staticClass: "grey lighten-5"
  }, [_c('page-section', {
    staticClass: "page-section--sm py-0"
  }, [_c('tit-wrap-large', {
    staticClass: "tit-wrap--lg"
  }, [_vm._v(" 식물 뿌리 환경을 관리하는 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _c('b', [_vm._v("스마트 관수 All In One 솔루션")])]), _c('v-row', {
    staticClass: "row--lg",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "4",
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-card', {
    staticClass: "text-center",
    attrs: {
      "rounded": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 372 / 210,
      "content-class": "d-flex align-center justify-center"
    }
  }, [_c('div', {
    staticClass: "pa-20px"
  }, [_c('div', [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "40",
      "aspect-ratio": 40 / 30,
      "src": "/images/icon/icon-sprout.svg"
    }
  }), _c('div', {
    staticClass: "mt-16px mt-md-24px"
  }, [_c('p', {
    staticClass: "txt txt--lg txt--dark line-height-15"
  }, [_vm._v("근권환경 수분 포함량을 "), _c('br', {
    staticClass: "d-md-none d-lg-block"
  }), _vm._v("기반으로 한 관수 시스템 적용")])])], 1)])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "4",
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('v-card', {
    staticClass: "text-center",
    attrs: {
      "rounded": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 372 / 210,
      "content-class": "d-flex align-center justify-center"
    }
  }, [_c('div', {
    staticClass: "pa-20px"
  }, [_c('div', [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "40",
      "aspect-ratio": 40 / 30,
      "src": "/images/icon/icon-sprout.svg"
    }
  }), _c('div', {
    staticClass: "mt-16px mt-md-24px"
  }, [_c('p', {
    staticClass: "txt txt--lg txt--dark line-height-15"
  }, [_vm._v("근권환경 데이터 학습을 통한 "), _c('br', {
    staticClass: "d-md-none d-lg-block"
  }), _vm._v("관수제어 알고리즘 생성")])])], 1)])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "4",
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('v-card', {
    staticClass: "text-center",
    attrs: {
      "rounded": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 372 / 210,
      "content-class": "d-flex align-center justify-center"
    }
  }, [_c('div', {
    staticClass: "pa-20px"
  }, [_c('div', [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "40",
      "aspect-ratio": 40 / 30,
      "src": "/images/icon/icon-sprout.svg"
    }
  }), _c('div', {
    staticClass: "mt-16px mt-md-24px"
  }, [_c('p', {
    staticClass: "txt txt--lg txt--dark line-height-15"
  }, [_vm._v("근권환경 측정을 통한 "), _c('br', {
    staticClass: "d-md-none d-lg-block"
  }), _vm._v("통합 솔루션 제공")])])], 1)])])], 1)], 1)], 1)], 1), _c('page-section', {
    staticClass: "page-section--sm pb-0"
  }, [_c('v-img', {
    staticClass: "ma-auto",
    attrs: {
      "max-width": "814",
      "aspect-ratio": 814 / 670,
      "src": "/images/sub/solution/smartfarm/irrigation-img5.png",
      "data-aos": "fade",
      "data-aos-delay": "400"
    }
  })], 1)], 1), _c('page-section', {
    staticClass: "page-section--last",
    attrs: {
      "id": "irrigation-portfolio"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v(" 포트폴리오 ")];
      },
      proxy: true
    }, {
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('div', {
          staticClass: "mx-auto px-12px",
          staticStyle: {
            "max-width": "1480px"
          }
        }, [_c('irrigation-slide')], 1)];
      },
      proxy: true
    }])
  }, [_c('div')])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }